import { render, staticRenderFns } from "./ColorSelection.vue?vue&type=template&id=db757324&"
import script from "./ColorSelection.vue?vue&type=script&lang=js&"
export * from "./ColorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports